var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('button',{attrs:{"id":"GoTop","type":"button"},on:{"click":_vm.goTop}},[_c('img',{staticClass:"glyphicon",attrs:{"src":require("../assets/images/top.png"),"alt":"返回顶部"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }